var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "ui-select",
        {
          opened: _vm.openedOnDesktop,
          loading: _vm.loading,
          disabled: _vm.disabled
        }
      ],
      on: { click: _vm.onClick }
    },
    [
      _vm.label
        ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "ui-select-input",
          on: {
            click: function($event) {
              return _vm.$emit("click-input")
            }
          }
        },
        [
          _vm.currentColor
            ? _c(
                "div",
                { staticClass: "ui-select-option-color" },
                [
                  _vm.currentColor.type === "code"
                    ? _c("div", {
                        staticClass: "color-code",
                        style: { backgroundColor: _vm.currentColor.color }
                      })
                    : _c("media", {
                        attrs: {
                          src: _vm.currentColor.color,
                          width: "24",
                          height: "24",
                          alt: _vm.currentColor.name
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _c("input", {
            ref: "input",
            attrs: {
              type: "text",
              autocomplete: "off",
              readonly: "",
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.currentName }
          }),
          _vm.loading
            ? _c("ui-loader")
            : _c("chevron-animated", {
                staticClass: "icon",
                attrs: { reverse: _vm.openedOnDesktop }
              })
        ],
        1
      ),
      _c(
        "div",
        {
          class: ["ui-select-options", { labeled: _vm.label }],
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "ui-dropdown",
            {
              attrs: { visible: _vm.openedOnDesktop },
              on: {
                "on-close": function($event) {
                  _vm.isOpened = false
                }
              }
            },
            _vm._l(_vm.computedOptions, function(option) {
              return _c(
                "div",
                {
                  key: option.id,
                  class: { chosen: option.value === _vm.value },
                  on: {
                    click: function($event) {
                      return _vm.select(option)
                    }
                  }
                },
                [
                  option.color
                    ? _c(
                        "div",
                        {
                          class: [
                            "ui-select-option-color",
                            { chosen: option.name === _vm.value }
                          ]
                        },
                        [
                          option.type === "code"
                            ? _c("div", {
                                staticClass: "color-code",
                                style: { backgroundColor: option.color }
                              })
                            : _c("media", {
                                attrs: {
                                  src: option.color,
                                  width: "24",
                                  height: "24",
                                  alt: option.name
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("span", [_vm._v(_vm._s(option.name))]),
                  !_vm.currentColor
                    ? _c("f-sprite-icon", {
                        attrs: { "icon-link": _vm.$options.icons.IconCheck.id }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _c("vue-client-only", [
        !_vm.adaptive.isDesktop && !_vm.currentColor
          ? _c(
              "select",
              {
                staticClass: "ui-select-native",
                domProps: { value: _vm.chosenOption },
                on: {
                  change: _vm.onNativeChange,
                  input: _vm.onNativeInput,
                  click: _vm.onNativeClick,
                  focusout: _vm.onNativeBlur
                }
              },
              _vm._l(_vm.computedOptions, function(option) {
                return _c(
                  "option",
                  {
                    key: option.id,
                    domProps: {
                      value: option.value,
                      selected: option.value == _vm.chosenOption
                    }
                  },
                  [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }